import { render, staticRenderFns } from "./ScrollShadowHorizontal.vue?vue&type=template&id=0b016a7d&scoped=true&"
import script from "./ScrollShadowHorizontal.vue?vue&type=script&lang=ts&"
export * from "./ScrollShadowHorizontal.vue?vue&type=script&lang=ts&"
import style0 from "./ScrollShadowHorizontal.vue?vue&type=style&index=0&id=0b016a7d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b016a7d",
  null
  
)

export default component.exports